import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon } from '@panwds/icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { Button } from '../Button/Button.esm.js';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';

/**
 * A clear button for a text input
 */
const ClearButton = forwardRef(({ addClassName, appearance = "tertiary-clear", iconSize = "sm", size = "sm", ...passThrough }, ref) => {
    const intl = useIntl();
    const label = intl.formatMessage({ id: "i6LYAv", defaultMessage: [{ type: 0, value: "Clear" }] });
    return (React.createElement(Button, { addClassName: classNames("tw-items-center", addClassName), "aria-label": label, appearance: appearance, icon: React.createElement(CloseIcon, { size: iconSize }), ref: ref, size: size, ...passThrough }));
});
ClearButton.displayName = "ClearButton";

export { ClearButton };
//# sourceMappingURL=ClearButton.esm.js.map
